import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import BigCalendar from 'react-big-calendar'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ModulePreview from '../../course/scheduleComponents/ModulePreview';

/* drag sources */
let eventSource = {
    beginDrag(props) {
        return Object.assign({},
            { event: props.event },

            { anchor: 'drop' }
        )
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}

class DraggableCourse extends Component {

    render() {
        let { connectDragSource, isDragging, event, previewData } = this.props;
        let EventWrapper = BigCalendar.components.eventWrapper;

        if (event.eventType === 'fullLesson') {
            return (
                <EventWrapper event={event}>
                    {connectDragSource(
                        <div>
                            <ExpansionPanel key={event.id} style={{ opacity: isDragging ? 0.5 : 1,  margin: '5px' }}>
                                <ExpansionPanelSummary style={{ backgroundColor: this.props.event.backgroundColor }} expandIcon={<ExpandMoreIcon />}>
                                   {this.props.event.modelName}
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    Single Lesson
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>
                    )}
                </EventWrapper>
            );
        }
        else {
            let max = previewData.length > 0 ? previewData[previewData.length - 1].WeekNum : 2
            return (
                <EventWrapper event={event}>
                    {connectDragSource(
                        <div>
                            <ExpansionPanel key={event.id} style={{ opacity: isDragging ? 0.5 : 1, margin: '5px' }} onChange={() => this.props.onExpand(event.id)}>
                                <ExpansionPanelSummary style={{ backgroundColor: this.props.event.backgroundColor, color: 'white' }} expandIcon={<ExpandMoreIcon />}>
                                    <span style={{ color: this.props.event.textColor }}>{this.props.event.modelName}</span>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <ModulePreview lessons={[{ lessons: previewData }]} maxWeeks={max} />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>
                    )}
                </EventWrapper>
            );
        }
    }
}


export default DragSource('event', eventSource, collectSource)(DraggableCourse);


// WEBPACK FOOTER //
// src/main/content/company/CompanyCalendar/DraggableCourse.js